import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EventFormModal.css';

export default function EventFormModal({ event, onClose, onEventAdded, onEventUpdated }) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    event_date: '',
    start_time: '',
    end_time: '',
    genre: '',
    instagram_url: '',
    club_id: '',
    location: '', // 일반 이벤트를 위한 장소 필드 추가
  });
  const [posterImage, setPosterImage] = useState(null);
  const [clubs, setClubs] = useState([]);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // 클럽 목록 불러오기
    const fetchClubs = async () => {
      const token = localStorage.getItem('ownerToken');
      try {
        const res = await axios.get('https://fastapi-backend-657266059621.asia-northeast1.run.app/api/owner/clubs', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setClubs(res.data);
        // 기본값 설정 제거 - 클럽 연결은 선택사항으로 변경
      } catch (err) {
        console.error('Error fetching clubs:', err);
        setError('클럽 정보를 불러오는 데 실패했습니다.');
      }
    };
    fetchClubs();

    if (event) {
      setFormData({
        title: event.title || '',
        description: event.description || '',
        event_date: event.event_date || '',
        start_time: event.start_time || '',
        end_time: event.end_time || '',
        genre: event.genre || '',
        instagram_url: event.instagram_url || '',
        club_id: event.club_id || '',
        location: event.location || '', // 기존 이벤트의 location 필드 처리
      });
    }
  }, [event]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setPosterImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    const token = localStorage.getItem('ownerToken');
    const submissionData = new FormData();
    Object.keys(formData).forEach(key => {
        if (key === 'club_id') {
            // club_id는 빈 값이어도 명시적으로 처리 (빈 값이면 null로 전송)
            if (formData[key]) {
                submissionData.append(key, formData[key]);
            }
        } else if (formData[key]) {
            submissionData.append(key, formData[key]);
        }
    });
    if (posterImage) {
      submissionData.append('poster_image', posterImage);
    }

    try {
        let response;
        const headers = { 'Authorization': `Bearer ${token}` };

        if (event) {
            response = await axios.put(`https://fastapi-backend-657266059621.asia-northeast1.run.app/api/owner/events/${event.id}`, submissionData, { headers });
            onEventUpdated(response.data);
        } else {
            response = await axios.post('https://fastapi-backend-657266059621.asia-northeast1.run.app/api/owner/events', submissionData, { headers });
            onEventAdded(response.data);
        }
    } catch (err) {
      console.error('Error submitting event:', err);
      setError(err.response?.data?.detail || '이벤트 저장에 실패했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{event ? '이벤트 수정' : '새 이벤트 추가'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>클럽 (선택사항)</label>
            <select name="club_id" value={formData.club_id} onChange={handleChange}>
              <option value="">클럽을 선택하거나 일반 이벤트로 등록</option>
              {clubs.map(club => (
                <option key={club.id} value={club.id}>{club.name}</option>
              ))}
            </select>
            <small className="form-help">클럽과 연관된 이벤트가 아닌 경우 선택하지 마세요.</small>
          </div>
          {!formData.club_id && (
            <div className="form-group">
              <label>장소</label>
              <input 
                type="text" 
                name="location" 
                value={formData.location} 
                onChange={handleChange} 
                placeholder="이벤트가 열리는 장소를 입력하세요"
                required 
              />
              <small className="form-help">클럽이 선택되지 않은 경우 필수 입력 사항입니다.</small>
            </div>
          )}
          <div className="form-group">
            <label>제목</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>날짜</label>
            <input type="date" name="event_date" value={formData.event_date} onChange={handleChange} required />
          </div>
          <div className="form-group time-group">
            <div className="time-input">
              <label>시작 시간</label>
              <input type="time" name="start_time" value={formData.start_time} onChange={handleChange} />
            </div>
            <div className="time-input">
              <label>종료 시간</label>
              <input type="time" name="end_time" value={formData.end_time} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label>장르</label>
            <input type="text" name="genre" value={formData.genre} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>인스타그램 URL</label>
            <input 
              type="url" 
              name="instagram_url" 
              value={formData.instagram_url} 
              onChange={handleChange} 
              placeholder="https://instagram.com/..." 
            />
          </div>
          <div className="form-group">
            <label>설명</label>
            <textarea 
              name="description" 
              value={formData.description} 
              onChange={handleChange}
              placeholder="이벤트 상세 설명을 입력하세요. (줄바꿈 가능)"
              rows="5"
            />
          </div>
          <div className="form-group">
            <label>포스터 이미지</label>
            <input type="file" name="poster_image" onChange={handleFileChange} />
          </div>

          {error && <p className="error-text">{error}</p>}
          
          <div className="form-actions">
            <button type="button" onClick={onClose} className="cancel-btn" disabled={isSubmitting}>취소</button>
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? '저장 중...' : '저장'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 